import config from "../config";
/**
 * Fetch tool settings data from API
 */
export const fetchToolSettings = async (token: string, schoolId: string, roleId: string) => {
  const TOOL_SETTINGS_API_URL = config.api.endpoints.TOOL_SETTINGS_STATUS(schoolId, roleId);

  try {
    const response = await fetch(TOOL_SETTINGS_API_URL, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch tool settings: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error while fetching tool settings:", error);
    return [];
  }
};
